export const invalidChar = (e : any) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();